import { render, staticRenderFns } from "./Comp2.vue?vue&type=template&id=7137fcea&"
import script from "./Comp2.vue?vue&type=script&lang=ts&"
export * from "./Comp2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports